webpackJsonp([11],{

/***/ 1105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftsList_vue__ = __webpack_require__(1252);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d5f93f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftsList_vue__ = __webpack_require__(1360);
function injectStyle (ssrContext) {
  __webpack_require__(1350)
  __webpack_require__(1352)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d5f93f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d5f93f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(frame) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/appearances/".concat(frame));
  },
  update: function update(frame, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put("/v2/appearances/".concat(frame), data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      silent: true
    });
  },
  reset: function reset(frame) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/appearances/".concat(frame), {
      silent: true
    });
  },
  deleteField: function deleteField(frame, key) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/appearances/".concat(frame, "/").concat(key), {
      silent: true
    });
  }
});

/***/ }),

/***/ 1158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getInvoices: function getInvoices(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nomination-invoices', {
      params: params
    });
  },
  getPdf: function getPdf(invoiceId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/nomination-invoices/".concat(invoiceId, "/pdf"), {
      silent: true
    });
  },
  getStripeSecret: function getStripeSecret(invoiceId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/nomination-invoices/".concat(invoiceId, "/stripe-client-secret"), {});
  },
  confirmPayment: function confirmPayment(invoiceId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/nomination-invoices/".concat(invoiceId, "/confirm-payment"), data, {
      silent: true
    });
  },
  resend: function resend(draftId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/nomination-invoices/users/").concat(userId, "/resend"), {}, {
      silent: true,
      localSuccess: true
    });
  },
  remind: function remind(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/nomination-invoices/remind"), {}, {
      silent: true,
      localSuccess: true
    });
  }
});

/***/ }),

/***/ 1159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultForm;
/* harmony export (immutable) */ __webpack_exports__["d"] = defaultPreviews;
/* harmony export (immutable) */ __webpack_exports__["a"] = applyResponse;
/* harmony export (immutable) */ __webpack_exports__["b"] = useAppearance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_appearances__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1160);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function defaultForm(config) {
  var form = {
    schema_color: '#aa2d41',
    sponsor_link: ''
  };

  if (config.hasLogoLinks) {
    for (var i = 1; i <= config.logoCount; i += 1) {
      form["sponsor_logo_".concat(i, "_link")] = '';
    }
  }

  return form;
}
function defaultPreviews(config) {
  var previews = {};
  config.fileKeys.forEach(function (key) {
    previews[key] = null;
  });
  return previews;
}
function applyResponse(form, previews, data, config) {
  form.schema_color = data.schema_color != null ? data.schema_color : '#aa2d41';
  form.sponsor_link = data.sponsor_link != null ? data.sponsor_link : '';

  if (config.hasLogoLinks) {
    for (var i = 1; i <= config.logoCount; i += 1) {
      var linkKey = "sponsor_logo_".concat(i, "_link");
      form[linkKey] = data[linkKey] != null ? data[linkKey] : '';
    }
  }

  config.fileKeys.forEach(function (key) {
    previews[key] = data[key] != null ? data[key] : null;
  });
}
function useAppearance(frameArg) {
  var frameRef = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["e" /* isRef */])(frameArg) ? frameArg : Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(frameArg);
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* FRAME_CONFIG */][frameRef.value];
  });
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var form = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])(defaultForm(config.value));
  var previews = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])(defaultPreviews(config.value));

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_appearances__["a" /* default */].get(frameRef.value);

            case 4:
              res = _context.sent;
              applyResponse(form, previews, res.data.data, config.value);

            case 6:
              _context.prev = 6;
              loading.value = false;
              return _context.finish(6);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 6, 9]]);
    }));
    return _fetch.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(frameRef, function () {
    Object.assign(form, defaultForm(config.value));
    Object.assign(previews, defaultPreviews(config.value));
    fetch();
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(fetch);
  return {
    loading: loading,
    form: form,
    previews: previews,
    config: config,
    fetch: fetch
  };
}

/***/ }),

/***/ 1160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LEADERBOARD_FILE_KEYS */
/* unused harmony export NOMINATIONS_FILE_KEYS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FRAME_CONFIG; });
var LEADERBOARD_FILE_KEYS = ['sponsor_logo_1', 'sponsor_logo_2', 'sponsor_logo_3', 'sponsor_logo_desktop', 'sponsor_logo_mobile'];
var NOMINATIONS_FILE_KEYS = ['sponsor_logo_1', 'sponsor_logo_2', 'sponsor_logo_desktop', 'sponsor_logo_mobile'];
var FRAME_CONFIG = {
  leaderboard: {
    title: 'Leaderboard Appearance',
    logoCount: 3,
    hasLogoLinks: true,
    fileKeys: LEADERBOARD_FILE_KEYS
  },
  nominations: {
    title: 'Nominations Appearance',
    logoCount: 2,
    hasLogoLinks: false,
    fileKeys: NOMINATIONS_FILE_KEYS
  }
};

/***/ }),

/***/ 1252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Leaders_Listing_components_AppearancesDraftsHeader__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Leaders_Listing_components_AppearancesDraftsDesktopBanner__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Nominations_components_MyDraftsSummary__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__composables_appearances_useAppearance__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__composables_useZones__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__composables_nominations_useNominationsList__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_date__ = __webpack_require__(148);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












function formatDate(str) {
  if (!str) return '—';
  return Object(__WEBPACK_IMPORTED_MODULE_10__utils_date__["c" /* formatLongDate */])(str);
}

function getDraftButton(draft) {
  if (draft.state == null) return null;
  var now = new Date();

  if (draft.state.id === 1) {
    var nomsOpen = new Date(draft.noms_open.replace(' ', 'T'));
    var nomsClosed = new Date(draft.noms_closed.replace(' ', 'T'));
    if (nomsOpen > now) return {
      text: "Opens ".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_date__["d" /* formatLongDateTime */])(draft.noms_open)),
      variant: 'disabled'
    };
    if (nomsClosed < now) return {
      text: 'Draft is being finalised',
      variant: 'outline'
    };
    return {
      text: 'Click here to nominate',
      variant: 'primary'
    };
  }

  if (draft.state.id === 5) return {
    text: 'Wait list is operating',
    variant: 'primary'
  };
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'NominationsDraftsList',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_3__components_Pagination__["a" /* default */],
    AppearancesDraftsHeader: __WEBPACK_IMPORTED_MODULE_4__views_Leaders_Listing_components_AppearancesDraftsHeader__["a" /* default */],
    AppearancesDraftsDesktopBanner: __WEBPACK_IMPORTED_MODULE_5__views_Leaders_Listing_components_AppearancesDraftsDesktopBanner__["a" /* default */],
    MyDraftsSummary: __WEBPACK_IMPORTED_MODULE_6__views_Nominations_components_MyDraftsSummary__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var _useAppearance = Object(__WEBPACK_IMPORTED_MODULE_7__composables_appearances_useAppearance__["b" /* default */])('nominations'),
        form = _useAppearance.form,
        previews = _useAppearance.previews;

    var _useZones = Object(__WEBPACK_IMPORTED_MODULE_8__composables_useZones__["a" /* default */])(),
        zones = _useZones.zones;

    var _useNominationsList = Object(__WEBPACK_IMPORTED_MODULE_9__composables_nominations_useNominationsList__["a" /* default */])(),
        items = _useNominationsList.items,
        loading = _useNominationsList.loading,
        zoneId = _useNominationsList.zoneId,
        currentPage = _useNominationsList.currentPage,
        lastPage = _useNominationsList.lastPage,
        fetch = _useNominationsList.fetch,
        setZone = _useNominationsList.setZone,
        setPage = _useNominationsList.setPage;

    var appearances = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return _objectSpread({}, previews, {}, form);
    });
    var hasMyDrafts = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var bannerHidden = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function onScroll() {
      if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 10) {
        bannerHidden.value = true;
      }
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      return window.addEventListener('scroll', onScroll);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["j" /* onUnmounted */])(function () {
      return window.removeEventListener('scroll', onScroll);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return proxy.$route.query;
    }, function (query) {
      setZone(query.zone_id != null ? query.zone_id : null);
      setPage(query.page != null ? Number(query.page) : 1);
      fetch();
    }, {
      immediate: true
    });

    function handleZoneChange(val) {
      var query = {};
      if (val !== '') query.zone_id = String(val);
      proxy.$router.replace({
        query: query
      }).catch(function () {});
    }

    function handlePageChange(page) {
      var query = _objectSpread({}, proxy.$route.query);

      if (page > 1) {
        query.page = String(page);
      } else {
        delete query.page;
      }

      proxy.$router.replace({
        query: query
      }).catch(function () {});
    }

    return {
      appearances: appearances,
      hasMyDrafts: hasMyDrafts,
      bannerHidden: bannerHidden,
      zones: zones,
      items: items,
      loading: loading,
      zoneId: zoneId,
      currentPage: currentPage,
      lastPage: lastPage,
      handleZoneChange: handleZoneChange,
      handlePageChange: handlePageChange,
      formatDate: formatDate,
      getDraftButton: getDraftButton
    };
  }
}));

/***/ }),

/***/ 1253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Leaders_Listing_components_AppearancesDraftsHeader__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_invoices__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__composables_nominations_useMyDraftsSummary__ = __webpack_require__(1357);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'MyDraftsSummary',
  components: {
    PageHeading: __WEBPACK_IMPORTED_MODULE_1__components_PageHeading__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_2__components_AppButton__["a" /* default */],
    AppearancesDraftsHeader: __WEBPACK_IMPORTED_MODULE_3__views_Leaders_Listing_components_AppearancesDraftsHeader__["a" /* default */]
  },
  props: {
    appearances: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _useMyDraftsSummary = Object(__WEBPACK_IMPORTED_MODULE_5__composables_nominations_useMyDraftsSummary__["a" /* default */])(),
        items = _useMyDraftsSummary.items,
        fetch = _useMyDraftsSummary.fetch;

    var generatingPdfIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(new Set());
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(items, function (val) {
      return emit('has-items', val.length > 0);
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      return fetch();
    });

    function viewInvoice(_x) {
      return _viewInvoice.apply(this, arguments);
    }

    function _viewInvoice() {
      _viewInvoice = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(invoiceId) {
        var res, url, next;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!generatingPdfIds.value.has(invoiceId)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                generatingPdfIds.value = new Set([].concat(_toConsumableArray(generatingPdfIds.value), [invoiceId]));
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_4__services_api_invoices__["a" /* default */].getPdf(invoiceId);

              case 6:
                res = _context.sent;
                url = res.data.data.url;

                if (url) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                window.open(url, '_blank');
                _context.next = 15;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);

              case 15:
                _context.prev = 15;
                next = new Set(generatingPdfIds.value);
                next.delete(invoiceId);
                generatingPdfIds.value = next;
                return _context.finish(15);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 13, 15, 20]]);
      }));
      return _viewInvoice.apply(this, arguments);
    }

    return {
      items: items,
      generatingPdfIds: generatingPdfIds,
      viewInvoice: viewInvoice
    };
  }
}));

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1351);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("2242ad10", content, true, {});

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".banner-fade-enter-active[data-v-4d5f93f2],.banner-fade-leave-active[data-v-4d5f93f2]{transition:opacity 1s}.banner-fade-enter[data-v-4d5f93f2],.banner-fade-leave-to[data-v-4d5f93f2]{opacity:0}.zone-filter[data-v-4d5f93f2]{background-color:var(--gray-50);padding:28px 32px;margin:0 16px 16px;border-radius:4px}.zone-filter__inner[data-v-4d5f93f2]{max-width:160px}.zone-filter__inner .form-label[data-v-4d5f93f2]{margin-bottom:4px;font-size:14px}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Nominations/DraftsList.vue"],"names":[],"mappings":"AACA,sFAEE,qBAAuB,CACxB,AACD,2EAEE,SAAW,CACZ,AACD,8BACE,gCAAiC,AACjC,kBAAmB,AACnB,mBAAoB,AACpB,iBAAmB,CACpB,AACD,qCACE,eAAiB,CAClB,AACD,iDACE,kBAAmB,AACnB,cAAgB,CACjB","file":"DraftsList.vue","sourcesContent":["\n.banner-fade-enter-active[data-v-4d5f93f2],\n.banner-fade-leave-active[data-v-4d5f93f2] {\n  transition: opacity 1s;\n}\n.banner-fade-enter[data-v-4d5f93f2],\n.banner-fade-leave-to[data-v-4d5f93f2] {\n  opacity: 0;\n}\n.zone-filter[data-v-4d5f93f2] {\n  background-color: var(--gray-50);\n  padding: 28px 32px;\n  margin: 0 16px 16px;\n  border-radius: 4px;\n}\n.zone-filter__inner[data-v-4d5f93f2] {\n  max-width: 160px;\n}\n.zone-filter__inner .form-label[data-v-4d5f93f2] {\n  margin-bottom: 4px;\n  font-size: 14px;\n}\n\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1353);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("74db6ae6", content, true, {});

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".leaderboard.nominate h1{color:var(--primary)!important}.nominate__click:disabled{pointer-events:none}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Nominations/DraftsList.vue"],"names":[],"mappings":"AACA,yBACE,8BAAiC,CAClC,AACD,0BACE,mBAAqB,CACtB","file":"DraftsList.vue","sourcesContent":["\n.leaderboard.nominate h1 {\n  color: var(--primary) !important;\n}\n.nominate__click:disabled {\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyDraftsSummary_vue__ = __webpack_require__(1253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de6a003_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyDraftsSummary_vue__ = __webpack_require__(1358);
function injectStyle (ssrContext) {
  __webpack_require__(1355)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4de6a003"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyDraftsSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de6a003_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyDraftsSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1356);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("93a498f4", content, true, {});

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".my-drafts-summary__header[data-v-4de6a003]{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;margin-bottom:8px}.my-drafts-summary__name[data-v-4de6a003]{font-weight:600}.my-drafts-summary__actions[data-v-4de6a003]{display:flex;gap:8px}.my-drafts-summary__blocks[data-v-4de6a003]{display:flex;flex-direction:column;gap:8px}.my-drafts-summary__block[data-v-4de6a003]{margin:0;padding:10px 20px 10px 35px;border:1px solid #61c0cf;border-radius:.25rem;color:#0e616e;background-color:#bee5eb;letter-spacing:1px}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Nominations/components/MyDraftsSummary.vue"],"names":[],"mappings":"AACA,4CACE,aAAc,AACd,eAAgB,AAChB,mBAAoB,AACpB,8BAA+B,AAC/B,QAAS,AACT,iBAAmB,CACpB,AACD,0CACE,eAAiB,CAClB,AACD,6CACE,aAAc,AACd,OAAS,CACV,AACD,4CACE,aAAc,AACd,sBAAuB,AACvB,OAAS,CACV,AACD,2CACE,SAAU,AACV,4BAA6B,AAC7B,yBAA0B,AAC1B,qBAAuB,AACvB,cAAe,AACf,yBAA0B,AAC1B,kBAAoB,CACrB","file":"MyDraftsSummary.vue","sourcesContent":["\n.my-drafts-summary__header[data-v-4de6a003] {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n.my-drafts-summary__name[data-v-4de6a003] {\n  font-weight: 600;\n}\n.my-drafts-summary__actions[data-v-4de6a003] {\n  display: flex;\n  gap: 8px;\n}\n.my-drafts-summary__blocks[data-v-4de6a003] {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.my-drafts-summary__block[data-v-4de6a003] {\n  margin: 0;\n  padding: 10px 20px 10px 35px;\n  border: 1px solid #61c0cf;\n  border-radius: 0.25rem;\n  color: #0e616e;\n  background-color: #bee5eb;\n  letter-spacing: 1px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMyDraftsSummary;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useMyDraftsSummary() {
  var items = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].myNominationsSummary();

            case 4:
              res = _context.sent;
              items.value = res.data.data != null ? res.data.data : [];
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);

            case 10:
              _context.prev = 10;
              loading.value = false;
              return _context.finish(10);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 10, 13]]);
    }));
    return _fetch.apply(this, arguments);
  }

  return {
    items: items,
    loading: loading,
    fetch: fetch
  };
}

/***/ }),

/***/ 1358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',[_c('page-heading',[_vm._v("Your Drafts")]),_vm._v(" "),_c('appearances-drafts-header',{attrs:{"appearances":_vm.appearances}}),_vm._v(" "),_vm._l((_vm.items),function(draft){return _c('div',{key:draft.id,staticClass:"my-drafts-summary__draft mb-3"},[_c('div',{staticClass:"my-drafts-summary__header"},[_c('div',{staticClass:"my-drafts-summary__name"},[_vm._v(_vm._s(draft.name)+" ("+_vm._s(draft.total_noms)+")")]),_vm._v(" "),_c('div',{staticClass:"my-drafts-summary__actions"},[_c('router-link',{staticClass:"btn btn-primary btn-sm",attrs:{"to":{ name: 'Nominations Add', params: { draftId: String(draft.id) } }}},[_vm._v("\n          View nominations\n        ")]),_vm._v(" "),(draft.invoice_id)?_c('app-button',{attrs:{"variant":"outline-primary","size":"sm","block":false,"loading":_vm.generatingPdfIds.has(draft.invoice_id)},on:{"click":function($event){return _vm.viewInvoice(draft.invoice_id)}}},[_vm._v("\n          View invoice\n        ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"my-drafts-summary__blocks"},[(draft.unprocessed)?_c('div',{staticClass:"my-drafts-summary__block"},[_vm._v("\n        You have ("+_vm._s(draft.unprocessed)+") nominations currently held and they will be processed by the secretary soon. Please be patient this can take up to three days.\n      ")]):_vm._e(),_vm._v(" "),(draft.accept_unpaid)?_c('div',{staticClass:"my-drafts-summary__block"},[_vm._v("\n        You have ("+_vm._s(draft.accept_unpaid)+") accepted but not yet paid nominations. The secretary will mark your nominations as paid when they receive your payment.\n      ")]):_vm._e(),_vm._v(" "),(draft.accept_paid)?_c('div',{staticClass:"my-drafts-summary__block"},[_vm._v("\n        You have ("+_vm._s(draft.accept_paid)+") accepted and fully paid nominations.\n      ")]):_vm._e(),_vm._v(" "),(draft.need_to_be_processed)?_c('div',{staticClass:"my-drafts-summary__block"},[_vm._v("\n        Due to excessive nominations draft restrictions have changed. Please click view nominations to process your nominations.\n      ")]):_vm._e(),_vm._v(" "),(draft.waitlist)?_c('div',{staticClass:"my-drafts-summary__block"},[_vm._v("\n        Sorry, due to excessive nominations we couldn't fit you in just yet. Please keep checking your nominations if space opens up we will try our best to fit you in!\n      ")]):_vm._e()])])})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useNominationsList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useNominationsList() {
  var items = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var zoneId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var currentPage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(1);
  var lastPage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(1);
  var total = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(0);

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var params, res, meta;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              params = {
                page: currentPage.value
              };
              if (zoneId.value != null) params.zone_id = zoneId.value;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].availableForNominations(params);

            case 6:
              res = _context.sent;
              items.value = res.data.data != null ? res.data.data : [];
              meta = res.data.meta != null ? res.data.meta : {};
              currentPage.value = meta.current_page != null ? meta.current_page : 1;
              lastPage.value = meta.last_page != null ? meta.last_page : 1;
              total.value = meta.total != null ? meta.total : 0;
              _context.next = 16;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);

            case 16:
              _context.prev = 16;
              loading.value = false;
              return _context.finish(16);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14, 16, 19]]);
    }));
    return _fetch.apply(this, arguments);
  }

  function setZone(id) {
    zoneId.value = id !== '' && id != null ? Number(id) : null;
    currentPage.value = 1;
  }

  function setPage(page) {
    currentPage.value = page;
  }

  return {
    items: items,
    loading: loading,
    zoneId: zoneId,
    currentPage: currentPage,
    lastPage: lastPage,
    total: total,
    fetch: fetch,
    setZone: setZone,
    setPage: setPage
  };
}

/***/ }),

/***/ 1360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{style:(_vm.appearances.schema_color 
      ? { 
        '--primary': _vm.appearances.schema_color,  
        '--primary-dark': _vm.appearances.schema_color,
        '--primary-rgb': _vm.appearances.schema_color,
      } : null),attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('div',{staticClass:"leaderboard nominate bg-white rounded mb-4"},[_c('div',{staticClass:"p-3"},[_c('my-drafts-summary',{attrs:{"appearances":_vm.appearances},on:{"has-items":function($event){_vm.hasMyDrafts = $event}}}),_vm._v(" "),_c('page-heading',[_vm._v("Upcoming and Other Drafts")]),_vm._v(" "),(!_vm.hasMyDrafts)?_c('appearances-drafts-header',{attrs:{"appearances":_vm.appearances}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"zone-filter"},[_c('div',{staticClass:"zone-filter__inner"},[_c('label',{staticClass:"form-label"},[_vm._v("Zone")]),_vm._v(" "),_c('select',{staticClass:"form-control",domProps:{"value":_vm.zoneId},on:{"change":function($event){return _vm.handleZoneChange($event.target.value)}}},[_c('option',{attrs:{"value":""}},[_vm._v("All")]),_vm._v(" "),_vm._l((_vm.zones),function(zone){return _c('option',{key:zone.id,domProps:{"value":zone.id}},[_vm._v(_vm._s(zone.code))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"position-relative"},[(_vm.loading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"__container nominate__item _type-other-drafts p-3"},[_c('appearances-drafts-desktop-banner',{attrs:{"appearances":_vm.appearances}}),_vm._v(" "),(!_vm.loading && _vm.items.length === 0)?_c('p',{staticClass:"text-muted"},[_vm._v("No drafts available")]):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(draft){return _c('div',{key:draft.id,staticClass:"draft"},[_c('div',{staticClass:"nominate__item-wrap-name"},[_vm._v(_vm._s(draft.name))]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_vm._v("Starts: "+_vm._s(_vm.formatDate(draft.start_date)))]),_vm._v(" "),(_vm.getDraftButton(draft))?[(_vm.getDraftButton(draft).variant === 'disabled')?_c('button',{staticClass:"nominate__click btn btn-secondary btn-sm btn-block",attrs:{"disabled":""}},[_vm._v("\n                "+_vm._s(_vm.getDraftButton(draft).text)+"\n              ")]):(_vm.getDraftButton(draft).variant === 'outline')?_c('router-link',{staticClass:"btn btn-outline-primary btn-sm btn-block",attrs:{"to":{ name: 'Nominations Add', params: { draftId: String(draft.id) } }}},[_vm._v("\n                "+_vm._s(_vm.getDraftButton(draft).text)+"\n              ")]):_c('router-link',{staticClass:"btn btn-primary btn-sm btn-block",attrs:{"to":{ name: 'Nominations Add', params: { draftId: String(draft.id) } }}},[_vm._v("\n                "+_vm._s(_vm.getDraftButton(draft).text)+"\n              ")])]:_vm._e()],2)})],2)]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('transition',{attrs:{"name":"banner-fade"}},[(_vm.appearances.sponsor_logo_mobile && !_vm.bannerHidden)?_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":_vm.appearances.sponsor_logo_mobile}})]):_vm._e()])],1)]),_vm._v(" "),(_vm.lastPage > 1)?_c('pagination',{staticClass:"paginate-leaderboard",attrs:{"page":_vm.currentPage,"total-pages":_vm.lastPage,"on-change":_vm.handlePageChange,"color":_vm.appearances.schema_color}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.7a5b7c870bbfcf4d7344.js